import localeJa from 'src/features/validation/yup.local.ja'
import * as Yup from 'yup'
import { setLocale } from 'yup'

setLocale(localeJa)

export default Yup
